/**
 * A page-wide scroll lock shared by every overlay that needs one.
 *
 * Two things make the obvious approach wrong on this site.
 *
 * The lock has to go on <html>. assets/sass/main.sass sets
 * `html { overflow-x: hidden }`, and once the root's overflow is anything but
 * visible, body's overflow no longer propagates to the viewport — so a lock
 * written to <body> is a silent no-op.
 *
 * And overlays nest. The mobile header stays tappable above the open menu, so
 * the search dialog can open on top of it. Having each overlay save the
 * previous value and restore it on close only works if they release in the
 * reverse of the order they locked, and on a route change they do not:
 * MobileNav's route watcher runs before its child SiteSearch's, so the menu
 * would restore "" while search still held the lock, then search would restore
 * "hidden" — and the page would stay frozen. Counting holders does not care
 * about order.
 */
let holders = 0;
let overflowBeforeLock = "";

export function useScrollLock() {
    // Per caller, so a component that unlocks twice cannot release a lock
    // another overlay is still holding.
    let holding = false;

    function lock() {
        if (holding || !import.meta.client) return;
        holding = true;
        if (holders++ === 0) {
            overflowBeforeLock = document.documentElement.style.overflow;
            document.documentElement.style.overflow = "hidden";
        }
    }

    function unlock() {
        if (!holding) return;
        holding = false;
        if (--holders === 0) {
            document.documentElement.style.overflow = overflowBeforeLock;
        }
    }

    // A holder that unmounts mid-lock must not leave the page frozen. That is
    // not hypothetical: layouts/default.vue swaps between the desktop and
    // mobile navs at 900px, which unmounts whichever one is showing.
    if (getCurrentInstance()) onBeforeUnmount(unlock);

    return { lock, unlock };
}
